
export default function SVGImport(){
    this.init = () => {
        var imgs = document.querySelectorAll('img.svg');
        imgs.forEach(function(img) {
            // Load SVG file
            var src = img.getAttribute('data-lazysrc') || img.src;
            var xhr = new XMLHttpRequest();
            
            xhr.open('GET', src, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    // Parse SVG content
                    img.style.display = 'none';

                    var parser = new DOMParser();
                    var svgContent = parser.parseFromString(xhr.responseText, 'image/svg+xml').documentElement;

                    // Append SVG content to the document
                    img.insertAdjacentElement('afterend', svgContent);

                    svgContent.classList = img.classList;
                    svgContent.classList.remove('svg');

                    // Optional: Hide the <img> element
                    img.remove();
                }
            };
            xhr.send();
        });
    }
}